export const collectionInvoiceType = {
  GET_COLLECTION_INVOICE_REQUEST: "GET_PROMO_CODE_REQUEST",
  GET_COLLECTION_INVOICE_SUCCESS: "GET_PROMO_CODE_SUCCESS",
  GET_COLLECTION_INVOICE_FAIL: "GET_PROMO_CODE_FAIL",
  GET_SINGLE_COLLECTION_INVOICE_REQUEST: "GET_SINGLE_COLLECTION_INVOICE_REQUEST",
  GET_SINGLE_COLLECTION_INVOICE_SUCCESS: "GET_SINGLE_COLLECTION_INVOICE_SUCCESS",
  GET_SINGLE_COLLECTION_INVOICE_FAIL: "GET_SINGLE_COLLECTION_INVOICE_FAIL",
  UPDATE_COLLECTION_INVOICE_REQUEST: "UPDATE_COLLECTION_INVOICE_REQUEST",
  UPDATE_COLLECTION_INVOICE_SUCCESS: "UPDATE_COLLECTION_INVOICE_SUCCESS",
  UPDATE_COLLECTION_INVOICE_FAIL: "UPDATE_COLLECTION_INVOICE_FAIL",
  GET_COLLECTION_INVOICE_PDF_REQUEST: "GET_COLLECTION_INVOICE_PDF_REQUEST",
  GET_COLLECTION_INVOICE_PDF_SUCCESS: "GET_COLLECTION_INVOICE_PDF_SUCCESS",
  GET_COLLECTION_INVOICE_PDF_FAIL: "GET_COLLECTION_INVOICE_PDF_FAIL"
};
